// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3EpAq","right":"styles_right__2dmsq"};